var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLogoEmpty(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 20,
    viewBox: "0 0 22 20",
    ref: svgRef
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#656666",
    strokeWidth: 1.5,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    d: "M19.638 8.898v9.078a1 1 0 01-1 1h-4.22a1 1 0 01-1-1V12.9a1 1 0 00-1-1H9.603a1 1 0 00-1 1v5.075a1 1 0 01-1 1H3.315a1 1 0 01-1-1V8.89h0c.219.09.456.141.7.141a1.861 1.861 0 001.461-.716c.125.314.305.597.53.832a2.384 2.384 0 001.642.749l.085.002c.653 0 1.255-.274 1.692-.718.162-.16.304-.349.416-.553.112.215.255.413.418.584.439.46 1.052.748 1.724.748.672 0 1.285-.287 1.726-.748.155-.162.29-.35.397-.553.11.204.246.39.403.555a2.388 2.388 0 001.726.749c.67 0 1.283-.288 1.725-.749.237-.246.424-.546.549-.88a1.864 1.864 0 001.445.698c.241 0 .472-.048.684-.134z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.82 5.59H1.112c-.024-.237.027-.48.152-.69L3.21 1.629c.19-.324.527-.519.887-.519H18.18c.392 0 .746.226.928.588l1.636 3.273c.127.255.152.349.077.619z"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    d: "M20.862 6.59v.442h0c0 .549-.212 1.054-.558 1.414a1.893 1.893 0 01-1.351.586 1.863 1.863 0 01-1.444-.698 2.546 2.546 0 01-.55.88 2.384 2.384 0 01-1.724.749c-.67 0-1.287-.288-1.726-.749a2.56 2.56 0 01-.403-.555c-.106.204-.242.39-.397.553a2.39 2.39 0 01-1.726.749 2.38 2.38 0 01-1.724-.749 2.545 2.545 0 01-.418-.584 2.445 2.445 0 01-.416.553 2.376 2.376 0 01-1.692.718l-.085-.002a2.386 2.386 0 01-1.642-.749 2.599 2.599 0 01-.53-.832 1.862 1.862 0 01-1.462.716 1.865 1.865 0 01-1.348-.586 2.043 2.043 0 01-.56-1.414V6.59a1 1 0 011-1h17.756a1 1 0 011 1z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoEmpty);
export default __webpack_public_path__ + "static/media/logo-empty.1a6aae2c.svg";
export { ForwardRef as ReactComponent };